import type { BillingStats } from './MembersRoster'

/**
 * The four org billing figures (Paid seats / Pending invites / Billing cadence / Seat cost) in a
 * bordered grid. Shared by the standalone MemberRosterModal (combined roster + billing) and the
 * settings-revamp admin-only BillingPanel so the figures render identically in both places.
 */
export function OrgBillingStats({ billingStats }: { billingStats: BillingStats }) {
  return (
    <div className="rounded-md border border-brand-neutral-200 bg-brand-neutral-50">
      <div className="grid grid-cols-2 sm:grid-cols-4">
        <div className="border-b border-r border-brand-neutral-200 px-5 py-3 sm:border-b-0">
          <p className="text-sm text-brand-neutral-600">Paid seats</p>
          <p className="text-lg font-semibold text-brand-neutral-950">{billingStats.paidSeats}</p>
        </div>
        <div className="border-b border-brand-neutral-200 px-5 py-3 sm:border-b-0 sm:border-r">
          <p className="text-sm text-brand-neutral-600">Pending invites</p>
          <p className="text-lg font-semibold text-brand-neutral-950">{billingStats.pendingInviteCount}</p>
        </div>
        <div className="border-r border-brand-neutral-200 px-5 py-3">
          <p className="text-sm text-brand-neutral-600">Billing cadence</p>
          <p className="text-lg font-semibold text-brand-neutral-950">{billingStats.billingCadence}</p>
        </div>
        <div className="px-5 py-3">
          <p className="text-sm text-brand-neutral-600">Seat cost</p>
          <p className="text-lg font-semibold text-brand-neutral-950">{billingStats.seatCost}</p>
        </div>
      </div>
    </div>
  )
}
